import styled from "@emotion/styled";

const MaxScreenHeight = styled.div`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
`;

export default MaxScreenHeight;
